import React, { useState } from "react";
import "./SikhaPhotoGalleryStyles.css";
import image1 from "../../../Assets/Multimedia/PhotoGallery/1.jpg";
import image2 from "../../../Assets/Multimedia/PhotoGallery/2.jpg";
import image3 from "../../../Assets/Multimedia/PhotoGallery/3.jpg";
import image4 from "../../../Assets/Multimedia/PhotoGallery/4.jpg";
import image5 from "../../../Assets/Multimedia/PhotoGallery/5.jpg";
import image6 from "../../../Assets/Multimedia/PhotoGallery/6.jpg";
import image7 from "../../../Assets/Multimedia/PhotoGallery/7.jpg";
import image8 from "../../../Assets/Multimedia/PhotoGallery/8.jpg";
import image9 from "../../../Assets/Multimedia/PhotoGallery/9.jpg";
import image10 from "../../../Assets/Multimedia/PhotoGallery/10.jpg";
import image11 from "../../../Assets/Multimedia/PhotoGallery/11.jpg";
import image12 from "../../../Assets/Multimedia/PhotoGallery/12.jpg";
import image13 from "../../../Assets/Multimedia/PhotoGallery/13.jpg";
import image14 from "../../../Assets/Multimedia/PhotoGallery/14.jpg";
import image15 from "../../../Assets/Multimedia/PhotoGallery/15.jpg";
import image16 from "../../../Assets/Multimedia/PhotoGallery/16.jpg";
import image17 from "../../../Assets/Multimedia/PhotoGallery/17.jpg";
import image18 from "../../../Assets/Multimedia/PhotoGallery/18.jpg";
import image19 from "../../../Assets/Multimedia/PhotoGallery/19.jpg";
import image20 from "../../../Assets/Multimedia/PhotoGallery/20.jpg";
import image21 from "../../../Assets/Multimedia/PhotoGallery/21.png";

const SikhaPhotoGallery = () => {
  // Array to hold image file paths
  const images = [
    image1,
    image2,
    image3,
    image4,
    image5,
    image6,
    image7,
    image8,
    image9,
    image10,
    image11,
    image12,
    image13,
    image14,
    image15,
    image16,
    image17,
    image18,
    image19,
    image20,
    image21,
  ];

  const [isModalOpen, setIsModalOpen] = useState(false); // State for modal open/close
  const [currentImageIndex, setCurrentImageIndex] = useState(0); // Index for current image in modal

  // Open modal and set the selected image
  const openModal = (index) => {
    setIsModalOpen(true);
    setCurrentImageIndex(index);
  };

  // Close modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Go to the next image
  const nextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  // Go to the previous image
  const prevImage = () => {
    setCurrentImageIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length,
    );
  };

  return (
    <div className="PhotoGallery-container">
      <h1>POUSH MELA PHOTO GALLERY</h1>
      {/* Display the image thumbnails in a grid */}
      <div className="photo_gallery">
        {images.map((image, index) => (
          <div
            className="thumbnail"
            key={index}
            onClick={() => openModal(index)}
          >
            <img src={image} alt={`thumbnail-${index}`} />
          </div>
        ))}
      </div>

      {/* Modal for image enlargement */}
      {isModalOpen && (
        <div className="photo-modal">
          <button className="photo-close" onClick={closeModal}>
            ×
          </button>

          <button className="photo-arrow photo-prev" onClick={prevImage}>
            ❮
          </button>

          <img
            src={images[currentImageIndex]}
            alt={`modal-img-${currentImageIndex}`}
            className="photo-modal-image"
          />

          <button className="photo-arrow photo-next" onClick={nextImage}>
            ❯
          </button>
        </div>
      )}
    </div>
  );
};

export default SikhaPhotoGallery;
